import { call, put, select } from 'redux-saga/effects';
import { generateTakeLatestSaga } from 'utils/sagas';
import request from 'utils/request';
import {
	SELF_HOSTED_PLANS,
	UPDATE_LICENSE
} from './constants';
import { find, findKey, get, join, map } from 'lodash';

import {
	selfHostedPlansSuccess,
	selfHostedPlansError,
	setError
} from './actions';
import { getPrices, removeFromCart, setErrorModal } from 'pages/App/actions';
import { selectCart } from 'pages/App/selectors';
import { selectPackages } from 'store/fonts/selectors';

// Request cart contents
export function* updateLicense(action) {
	try {
		const cart = yield select(selectCart());
		const packages = yield select(selectPackages());

		if (!packages) {
			return;
		}

		const packageIDs = join(map(packages, 'id'));
		const inCart = !!findKey(action.data, 'inCart') || !!findKey(action.data, 'value');

		// If user changes a computer license to 0 and has an app license in the cart, remove the
		// app license
		const computers = get(action, 'data.computer.value', null);
		if (computers === 0) {
			// Remove app license from cart if it exists and user selects 0 computers
			const cartItems = get(cart, 'items');
			const appInCart = find(cartItems, (item) => item.licenseType === 'app_license');
			if (appInCart) {
				const cartItemID = appInCart.cartRecordID;
				yield put(removeFromCart({
					ids: cartItemID,
					type: 'app'
				}));
			}
		}

		if (inCart) {
			yield put(getPrices(packageIDs));
		}
	} catch (err) {
		const message = get(err, 'response.data.error.message', err.message);
		yield put(setError({ type: 'updateLicense', error: message }));
		yield put(setErrorModal());
	}
}

export function* getSelfHostedPlans() {
	const url = '/api/v1/self_hosted_pageviews?show_on_website=true&serializer=array';
	try {
		const response = yield call(request, url);
		yield put(selfHostedPlansSuccess(response.data.self_hosted_pageviews));
	} catch (err) {
		yield put(selfHostedPlansError(err.message));
	}
}

/* _____________________________________________________________________________
 * Root saga watchers
 *
 * Since we're code-splitting on routes and load the saga with each route
 * change, we need to ensure that the sagas aren't run more than once.
 * ___________________________________________________________________________*/

export const updateLicenseSaga = generateTakeLatestSaga(UPDATE_LICENSE, updateLicense);
export const getSelfHostedPlansSaga = generateTakeLatestSaga(SELF_HOSTED_PLANS, getSelfHostedPlans);

// Bootstrap sagas
export default [
	getSelfHostedPlansSaga,
	updateLicenseSaga
];
